const THERE_WAS_AN_ERROR = 'There was an error';
export const PRODUCT = {
  productErrorMessage: `${THERE_WAS_AN_ERROR} fetching all products`,
};
